/**
 * @generated SignedSource<<ee4ab5532711622a45102978b5655f83>>
 * @relayHash 5a21e9b263bb5f498b502ec08765fc48
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

// @relayRequestID 5a21e9b263bb5f498b502ec08765fc48

var node = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "display"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "length"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "message"
},
v3 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "display",
        "variableName": "display"
      },
      {
        "kind": "Variable",
        "name": "length",
        "variableName": "length"
      },
      {
        "kind": "Variable",
        "name": "message",
        "variableName": "message"
      }
    ],
    "concreteType": "BasicResponse",
    "kind": "LinkedField",
    "name": "updateHomeMessage",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "ok",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "error",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "UpdateHomeMessageMutation",
    "selections": (v3/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "UpdateHomeMessageMutation",
    "selections": (v3/*: any*/)
  },
  "params": {
    "id": "5a21e9b263bb5f498b502ec08765fc48",
    "metadata": {},
    "name": "UpdateHomeMessageMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

node.hash = "1dd011513096cac2158dc32a5f1a7daa";

export default node;
